import React from 'react';
import './Skeleton.css';

/**
 * Skeleton loader для контента
 */
export function Skeleton({ width, height, className, variant = 'text' }) {
  return (
    <div
      className={`skeleton skeleton-${variant} ${className || ''}`}
      style={{
        width: width || '100%',
        height: height || (variant === 'circular' ? '40px' : '16px'),
        borderRadius: variant === 'circular' ? '50%' : variant === 'rounded' ? '8px' : '4px',
      }}
    />
  );
}

/**
 * Skeleton для карточки
 */
export function SkeletonCard({ count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={`skel-card-${i}`} className="skeleton-card">
          <Skeleton variant="image" height="200px" />
          <div className="skeleton-card-content">
            <Skeleton width="60%" />
            <Skeleton width="80%" />
            <Skeleton width="40%" />
          </div>
        </div>
      ))}
    </>
  );
}

/**
 * Skeleton для таблицы
 */
export function SkeletonTable({ rows = 5, columns = 4 }) {
  return (
    <div className="skeleton-table">
      <div className="skeleton-table-header">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={`skel-th-${i}`} className="skeleton-table-cell" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={`skel-row-${rowIndex}`} className="skeleton-table-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton key={`skel-cell-${rowIndex}-${colIndex}`} className="skeleton-table-cell" />
          ))}
        </div>
      ))}
    </div>
  );
}

/**
 * Skeleton для текста
 */
export function SkeletonText({ lines = 3, width = '100%' }) {
  return (
    <div className="skeleton-text">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={`skel-line-${i}`}
          width={i === lines - 1 ? `${parseInt(width) * 0.6}%` : width}
          className="skeleton-text-line"
        />
      ))}
    </div>
  );
}

/**
 * Skeleton для аватара
 */
export function SkeletonAvatar({ size = 40 }) {
  return (
    <Skeleton
      variant="circular"
      width={`${size}px`}
      height={`${size}px`}
      className="skeleton-avatar"
    />
  );
}

/**
 * Skeleton для графика
 */
export function SkeletonChart({ height = 300 }) {
  return (
    <div className="skeleton-chart">
      <Skeleton height={`${height}px`} variant="rounded" />
    </div>
  );
}

export default Skeleton;
